import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Image,
  TextInput,
  FlatList,
  RefreshControl,
  Animated,
  ActivityIndicator,
  Alert,
} from 'react-native';
import { Ionicons, MaterialIcons, FontAwesome5 } from '@expo/vector-icons';
import * as DocumentPicker from 'expo-document-picker';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
// JOBENG Logo component
const JobengLogo = () => (
  <Image
    source={require('../../../assets/jobeng_icon.png')}
    style={{ width: 30, height: 30 }}
    resizeMode="contain"
  />
);

export default function CareerFairRegistrationScreen({ navigation, route }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_careerfairregistrationscreen`;
    apiFetch('/api/data/applications?sort=created_at&order=desc&limit=10').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // States
  const [isLoading, setIsLoading] = useState(true);
  const [fairDetails, setFairDetails] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    university: '',
    degree: '',
    graduationYear: '',
    interests: [],
    resume: null,
    specialRequirements: '',
    attendanceType: 'in-person', // 'in-person' or 'virtual'
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Animation values
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(50)).current;

  // Mock career fair data
  const mockCareerFairs = [
    {
      id: 'fair1',
      title: 'London Engineering & Technology Fair 2025',
      organizer: 'UK Engineering Council',
      location: 'ExCeL London',
      date: '2025-09-15',
      time: '10:00 - 17:00',
      logo: 'https://logo.clearbit.com/engc.org.uk',
      isVirtual: false,
      hasVirtualOption: true,
      description:
        'The largest engineering and technology career fair in London, featuring over 100 top employers from various engineering disciplines. This event provides an excellent opportunity for students and professionals to connect with leading companies in the industry.',
      benefits: [
        'Meet recruiters from top engineering firms',
        'Attend industry workshops and presentations',
        'Get CV reviews and career advice',
        'Network with industry professionals',
        'Explore graduate schemes and internship opportunities',
      ],
      participatingCompanies: [
        {
          id: 'c1',
          name: 'Rolls-Royce',
          logo: 'https://logo.clearbit.com/rolls-royce.com',
          industries: ['Aerospace', 'Defense', 'Power Systems'],
        },
        {
          id: 'c2',
          name: 'BAE Systems',
          logo: 'https://logo.clearbit.com/baesystems.com',
          industries: ['Defense', 'Security', 'Aerospace'],
        },
        {
          id: 'c3',
          name: 'Arup',
          logo: 'https://logo.clearbit.com/arup.com',
          industries: ['Civil Engineering', 'Construction', 'Design'],
        },
        {
          id: 'c4',
          name: 'Siemens',
          logo: 'https://logo.clearbit.com/siemens.com',
          industries: ['Electrical Engineering', 'Automation', 'Healthcare'],
        },
        {
          id: 'c5',
          name: 'BP',
          logo: 'https://logo.clearbit.com/bp.com',
          industries: ['Energy', 'Oil & Gas', 'Renewables'],
        },
      ],
      schedule: [
        {
          time: '10:00 - 10:30',
          event: 'Opening Address',
          location: 'Main Hall',
        },
        {
          time: '10:30 - 12:30',
          event: 'Morning Exhibition Session',
          location: 'Exhibition Hall',
        },
        {
          time: '12:30 - 13:30',
          event: 'Lunch Break & Networking',
          location: 'Dining Area',
        },
        {
          time: '13:30 - 15:00',
          event: 'Industry Panel: Future of Engineering',
          location: 'Conference Room A',
        },
        {
          time: '15:00 - 17:00',
          event: 'Afternoon Exhibition Session',
          location: 'Exhibition Hall',
        },
      ],
      registrationDeadline: '2025-09-10',
    },
    {
      id: 'fair2',
      title: 'Virtual Tech Careers Expo 2025',
      organizer: 'TechUK',
      location: 'Online',
      date: '2025-08-05',
      time: '09:00 - 16:00',
      logo: 'https://logo.clearbit.com/techuk.org',
      isVirtual: true,
      hasVirtualOption: true,
      description:
        'A fully virtual career fair focused on technology roles across the UK. Connect with employers, attend webinars, and participate in virtual networking sessions from anywhere.',
      benefits: [
        'Access from anywhere with internet connection',
        'Live video chats with recruiters',
        'Virtual booths from leading tech companies',
        'Downloadable resources and job descriptions',
        'On-demand presentations and workshops',
      ],
      participatingCompanies: [
        {
          id: 'c6',
          name: 'Google',
          logo: 'https://logo.clearbit.com/google.com',
          industries: ['Software', 'Cloud Computing', 'AI'],
        },
        {
          id: 'c7',
          name: 'Microsoft',
          logo: 'https://logo.clearbit.com/microsoft.com',
          industries: ['Software', 'Cloud Services', 'Hardware'],
        },
        {
          id: 'c8',
          name: 'IBM',
          logo: 'https://logo.clearbit.com/ibm.com',
          industries: ['IT Services', 'Cloud Computing', 'AI'],
        },
        {
          id: 'c9',
          name: 'Sage',
          logo: 'https://logo.clearbit.com/sage.com',
          industries: [
            'Software',
            'Financial Technology',
            'Business Solutions',
          ],
        },
        {
          id: 'c10',
          name: 'Arm',
          logo: 'https://logo.clearbit.com/arm.com',
          industries: ['Semiconductor', 'Chip Design', 'IoT'],
        },
      ],
      schedule: [
        {
          time: '09:00 - 09:30',
          event: 'Virtual Welcome Session',
          location: 'Main Virtual Hall',
        },
        {
          time: '09:30 - 12:00',
          event: 'Morning Company Booths',
          location: 'Virtual Exhibition Space',
        },
        {
          time: '12:00 - 13:00',
          event: 'Webinar: Tech Industry Trends 2025',
          location: 'Virtual Auditorium',
        },
        {
          time: '13:00 - 14:00',
          event: 'Break',
          location: 'N/A',
        },
        {
          time: '14:00 - 16:00',
          event: 'Afternoon Company Booths & Networking',
          location: 'Virtual Exhibition Space',
        },
      ],
      registrationDeadline: '2025-08-03',
    },
    {
      id: 'fair3',
      title: 'Graduate Engineering Recruitment Day',
      organizer: 'University of Manchester',
      location: 'Manchester University Campus',
      date: '2025-10-20',
      time: '11:00 - 16:00',
      logo: 'https://logo.clearbit.com/manchester.ac.uk',
      isVirtual: false,
      hasVirtualOption: false,
      description:
        'A specialized career fair for engineering graduates, featuring companies with graduate schemes and entry-level positions. This event is specifically designed for final-year students and recent graduates.',
      benefits: [
        'Focus on graduate schemes and entry-level positions',
        'On-site interviews for selected candidates',
        'Graduate-focused workshops and presentations',
        'Alumni networking opportunities',
        'Information on further study options',
      ],
      participatingCompanies: [
        {
          id: 'c11',
          name: 'Jaguar Land Rover',
          logo: 'https://logo.clearbit.com/jaguarlandrover.com',
          industries: ['Automotive', 'Manufacturing'],
        },
        {
          id: 'c12',
          name: 'Airbus',
          logo: 'https://logo.clearbit.com/airbus.com',
          industries: ['Aerospace', 'Defense'],
        },
        {
          id: 'c13',
          name: 'National Grid',
          logo: 'https://logo.clearbit.com/nationalgrid.com',
          industries: ['Energy', 'Utilities'],
        },
        {
          id: 'c14',
          name: 'Dyson',
          logo: 'https://logo.clearbit.com/dyson.com',
          industries: ['Consumer Electronics', 'Technology'],
        },
        {
          id: 'c15',
          name: 'Network Rail',
          logo: 'https://logo.clearbit.com/networkrail.co.uk',
          industries: ['Transportation', 'Infrastructure'],
        },
      ],
      schedule: [
        {
          time: '11:00 - 11:30',
          event: 'Welcome and Introduction',
          location: 'Main Lecture Hall',
        },
        {
          time: '11:30 - 13:30',
          event: 'Company Exhibitions',
          location: 'Engineering Building',
        },
        {
          time: '13:30 - 14:30',
          event: 'Lunch and Networking',
          location: 'University Canteen',
        },
        {
          time: '14:30 - 15:30',
          event: 'Panel: From Graduate to Professional',
          location: 'Seminar Room 1',
        },
        {
          time: '15:30 - 16:00',
          event: 'Closing Session and Next Steps',
          location: 'Main Lecture Hall',
        },
      ],
      registrationDeadline: '2025-10-15',
    },
  ];

  // Interest options
  const interestOptions = [
    'Aerospace Engineering',
    'Automotive Engineering',
    'Biomedical Engineering',
    'Chemical Engineering',
    'Civil Engineering',
    'Computer Engineering',
    'Electrical Engineering',
    'Environmental Engineering',
    'Industrial Engineering',
    'Materials Engineering',
    'Mechanical Engineering',
    'Software Engineering',
    'Structural Engineering',
    'Systems Engineering',
    'Telecommunications Engineering',
  ];

  // Load career fair details
  useEffect(() => {
    if (!route.params?.fairId) {
      setErrors({ general: 'No career fair ID provided' });
      setIsLoading(false);
      return;
    }

    // Simulate API call
    setTimeout(() => {
      const fair = mockCareerFairs.find(f => f.id === route.params.fairId);

      if (fair) {
        setFairDetails(fair);
      } else {
        setErrors({ general: 'Career fair not found' });
      }

      setIsLoading(false);

      // Animate content in
      Animated.parallel([
        Animated.timing(fadeAnim, {
          toValue: 1,
          duration: 500,
          useNativeDriver: true,
        }),
        Animated.timing(slideAnim, {
          toValue: 0,
          duration: 500,
          useNativeDriver: true,
        }),
      ]).start();
    }, 1500);
  }, [route.params?.fairId, fadeAnim, slideAnim]);

  // Format date
  const formatDate = dateString => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  // Handle form input change
  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));

    // Clear error for this field if it exists
    if (errors[field]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  // Handle interest selection
  const handleInterestToggle = interest => {
    setFormData(prev => {
      const currentInterests = [...prev.interests];

      if (currentInterests.includes(interest)) {
        // Remove interest if already selected
        return {
          ...prev,
          interests: currentInterests.filter(i => i !== interest),
        };
      } else {
        // Add interest if not already selected
        return {
          ...prev,
          interests: [...currentInterests, interest],
        };
      }
    });

    // Clear interest error if it exists
    if (errors.interests) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.interests;
        return newErrors;
      });
    }
  };

  // Handle attendance type selection
  const handleAttendanceTypeChange = type => {
    setFormData(prev => ({
      ...prev,
      attendanceType: type,
    }));
  };

  // Handle resume upload
  const handleResumeUpload = async () => {
    try {
      const result = await DocumentPicker.getDocumentAsync({
        type: [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ],
        copyToCacheDirectory: true,
      });

      if (result.canceled) {
        return;
      }

      setFormData(prev => ({
        ...prev,
        resume: {
          name: result.assets[0].name,
          uri: result.assets[0].uri,
          size: result.assets[0].size,
        },
      }));

      // Clear resume error if it exists
      if (errors.resume) {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors.resume;
          return newErrors;
        });
      }
    } catch (error) {
      Alert.alert('Error', 'Failed to upload resume. Please try again.');
    }
  };

  // Validate form data
  const validateForm = () => {
    const newErrors = {};

    // Step 1 validation
    if (currentStep === 1) {
      if (!formData.firstName.trim())
        newErrors.firstName = 'First name is required';
      if (!formData.lastName.trim())
        newErrors.lastName = 'Last name is required';
      if (!formData.email.trim()) {
        newErrors.email = 'Email is required';
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = 'Email is invalid';
      }
      if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
    }

    // Step 2 validation
    if (currentStep === 2) {
      if (!formData.university.trim())
        newErrors.university = 'University/Institution is required';
      if (!formData.degree.trim())
        newErrors.degree = 'Degree/Course is required';
      if (!formData.graduationYear.trim()) {
        newErrors.graduationYear = 'Graduation year is required';
      } else if (!/^\d{4}$/.test(formData.graduationYear)) {
        newErrors.graduationYear = 'Please enter a valid year (e.g., 2025)';
      }
      if (formData.interests.length === 0)
        newErrors.interests = 'Please select at least one interest';
    }

    // Step 3 validation
    if (currentStep === 3) {
      if (!formData.resume) newErrors.resume = 'Resume/CV is required';

      // Only validate attendance type for fairs with virtual options
      if (fairDetails?.hasVirtualOption && !formData.attendanceType) {
        newErrors.attendanceType = 'Please select your attendance type';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle next step
  const handleNextStep = () => {
    if (validateForm()) {
      setCurrentStep(prev => prev + 1);

      // Scroll to top when changing steps
      setTimeout(() => {
        if (scrollViewRef.current) {
          scrollViewRef.current.scrollTo({ y: 0, animated: true });
        }
      }, 100);
    }
  };

  // Handle previous step
  const handlePrevStep = () => {
    setCurrentStep(prev => Math.max(1, prev - 1));

    // Scroll to top when changing steps
    setTimeout(() => {
      if (scrollViewRef.current) {
        scrollViewRef.current.scrollTo({ y: 0, animated: true });
      }
    }, 100);
  };

  // Handle form submission
  const handleSubmit = () => {
    if (validateForm()) {
      setIsSubmitting(true);

      // Simulate API call
      setTimeout(() => {
        setIsSubmitting(false);

        // Show success message
        Alert.alert(
          'Registration Successful',
          `You have successfully registered for ${fairDetails.title}. You will receive a confirmation email with further details shortly.`,
          [
            {
              text: 'OK',
              onPress: () => navigation.navigate('CareerFairs'),
            },
          ]
        );
      }, 2000);
    }
  };

  // Scroll view reference
  const scrollViewRef = useRef(null);

  // Render error state
  const renderError = () => (
    <View style={styles.errorContainer}>
      <Ionicons name="alert-circle-outline" size={60} color="#EF4444" />
      <Text style={styles.errorTitle}>Error</Text>
      <Text style={styles.errorMessage}>
        {errors.general || 'An unexpected error occurred'}
      </Text>
      <TouchableOpacity
        style={styles.errorButton}
        onPress={() => navigation.goBack()}
      >
        <Text style={styles.errorButtonText}>Go Back</Text>
      </TouchableOpacity>
    </View>
  );

  // Render step indicator
  const renderStepIndicator = () => (
    <View style={styles.stepIndicatorContainer}>
      <View style={styles.stepIndicator}>
        <View
          style={[
            styles.stepCircle,
            currentStep >= 1 && styles.activeStepCircle,
          ]}
        >
          <Text
            style={[
              styles.stepNumber,
              currentStep >= 1 && styles.activeStepNumber,
            ]}
          >
            1
          </Text>
        </View>
        <Text
          style={[styles.stepLabel, currentStep >= 1 && styles.activeStepLabel]}
        >
          Personal Info
        </Text>
      </View>

      <View style={styles.stepConnector} />

      <View style={styles.stepIndicator}>
        <View
          style={[
            styles.stepCircle,
            currentStep >= 2 && styles.activeStepCircle,
          ]}
        >
          <Text
            style={[
              styles.stepNumber,
              currentStep >= 2 && styles.activeStepNumber,
            ]}
          >
            2
          </Text>
        </View>
        <Text
          style={[styles.stepLabel, currentStep >= 2 && styles.activeStepLabel]}
        >
          Education
        </Text>
      </View>

      <View style={styles.stepConnector} />

      <View style={styles.stepIndicator}>
        <View
          style={[
            styles.stepCircle,
            currentStep >= 3 && styles.activeStepCircle,
          ]}
        >
          <Text
            style={[
              styles.stepNumber,
              currentStep >= 3 && styles.activeStepNumber,
            ]}
          >
            3
          </Text>
        </View>
        <Text
          style={[styles.stepLabel, currentStep >= 3 && styles.activeStepLabel]}
        >
          Documents
        </Text>
      </View>

      <View style={styles.stepConnector} />

      <View style={styles.stepIndicator}>
        <View
          style={[
            styles.stepCircle,
            currentStep >= 4 && styles.activeStepCircle,
          ]}
        >
          <Text
            style={[
              styles.stepNumber,
              currentStep >= 4 && styles.activeStepNumber,
            ]}
          >
            4
          </Text>
        </View>
        <Text
          style={[styles.stepLabel, currentStep >= 4 && styles.activeStepLabel]}
        >
          Review
        </Text>
      </View>
    </View>
  );

  // Render step 1: Personal Information
  const renderStep1 = () => (
    <View style={styles.stepContainer}>
      <Text style={styles.stepTitle}>Personal Information</Text>
      <Text style={styles.stepDescription}>
        Please provide your personal details for the career fair registration.
      </Text>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>First Name *</Text>
        <TextInput
          style={[styles.input, errors.firstName && styles.inputError]}
          placeholder="Enter your first name"
          value={formData.firstName}
          onChangeText={text => handleInputChange('firstName', text)}
        />
        {errors.firstName && (
          <Text style={styles.errorText}>{errors.firstName}</Text>
        )}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Last Name *</Text>
        <TextInput
          style={[styles.input, errors.lastName && styles.inputError]}
          placeholder="Enter your last name"
          value={formData.lastName}
          onChangeText={text => handleInputChange('lastName', text)}
        />
        {errors.lastName && (
          <Text style={styles.errorText}>{errors.lastName}</Text>
        )}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Email Address *</Text>
        <TextInput
          style={[styles.input, errors.email && styles.inputError]}
          placeholder="Enter your email address"
          keyboardType="email-address"
          autoCapitalize="none"
          value={formData.email}
          onChangeText={text => handleInputChange('email', text)}
        />
        {errors.email && <Text style={styles.errorText}>{errors.email}</Text>}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Phone Number *</Text>
        <TextInput
          style={[styles.input, errors.phone && styles.inputError]}
          placeholder="Enter your phone number"
          keyboardType="phone-pad"
          value={formData.phone}
          onChangeText={text => handleInputChange('phone', text)}
        />
        {errors.phone && <Text style={styles.errorText}>{errors.phone}</Text>}
      </View>
    </View>
  );

  // Render step 2: Education and Interests
  const renderStep2 = () => (
    <View style={styles.stepContainer}>
      <Text style={styles.stepTitle}>Education & Interests</Text>
      <Text style={styles.stepDescription}>
        Please provide information about your education and areas of interest.
      </Text>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>University/Institution *</Text>
        <TextInput
          style={[styles.input, errors.university && styles.inputError]}
          placeholder="Enter your university or institution"
          value={formData.university}
          onChangeText={text => handleInputChange('university', text)}
        />
        {errors.university && (
          <Text style={styles.errorText}>{errors.university}</Text>
        )}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Degree/Course *</Text>
        <TextInput
          style={[styles.input, errors.degree && styles.inputError]}
          placeholder="Enter your degree or course"
          value={formData.degree}
          onChangeText={text => handleInputChange('degree', text)}
        />
        {errors.degree && <Text style={styles.errorText}>{errors.degree}</Text>}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Graduation Year *</Text>
        <TextInput
          style={[styles.input, errors.graduationYear && styles.inputError]}
          placeholder="Enter your graduation year (e.g., 2025)"
          keyboardType="number-pad"
          maxLength={4}
          value={formData.graduationYear}
          onChangeText={text => handleInputChange('graduationYear', text)}
        />
        {errors.graduationYear && (
          <Text style={styles.errorText}>{errors.graduationYear}</Text>
        )}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Areas of Interest *</Text>
        <Text style={styles.inputDescription}>
          Select the engineering fields you are interested in (select at least
          one).
        </Text>
        {errors.interests && (
          <Text style={styles.errorText}>{errors.interests}</Text>
        )}

        <View style={styles.interestsContainer}>
          {interestOptions.map(interest => (
            <TouchableOpacity
              key={interest}
              style={[
                styles.interestChip,
                formData.interests.includes(interest) &&
                  styles.selectedInterestChip,
              ]}
              onPress={() => handleInterestToggle(interest)}
            >
              <Text
                style={[
                  styles.interestChipText,
                  formData.interests.includes(interest) &&
                    styles.selectedInterestChipText,
                ]}
              >
                {interest}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>
    </View>
  );

  // Render step 3: Documents and Preferences
  const renderStep3 = () => (
    <View style={styles.stepContainer}>
      <Text style={styles.stepTitle}>Documents & Preferences</Text>
      <Text style={styles.stepDescription}>
        Please upload your resume and specify your attendance preferences.
      </Text>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Resume/CV *</Text>
        <Text style={styles.inputDescription}>
          Upload your resume or CV (PDF or Word format).
        </Text>

        <TouchableOpacity
          style={styles.uploadButton}
          onPress={handleResumeUpload}
        >
          <Ionicons name="document-outline" size={20} color="#0e4e96" />
          <Text style={styles.uploadButtonText}>
            {formData.resume
              ? 'Resume Uploaded: ' + formData.resume.name
              : 'Upload Resume/CV'}
          </Text>
        </TouchableOpacity>
        {errors.resume && <Text style={styles.errorText}>{errors.resume}</Text>}
      </View>

      {fairDetails?.hasVirtualOption && (
        <View style={styles.formGroup}>
          <Text style={styles.inputLabel}>Attendance Type *</Text>
          <Text style={styles.inputDescription}>
            Please select how you would like to attend this career fair.
          </Text>

          <View style={styles.attendanceOptions}>
            <TouchableOpacity
              style={[
                styles.attendanceOption,
                formData.attendanceType === 'in-person' &&
                  styles.selectedAttendanceOption,
              ]}
              onPress={() => handleAttendanceTypeChange('in-person')}
              disabled={fairDetails.isVirtual}
            >
              <View style={styles.attendanceOptionContent}>
                <View
                  style={[
                    styles.radioButton,
                    formData.attendanceType === 'in-person' &&
                      styles.selectedRadioButton,
                    fairDetails.isVirtual && styles.disabledRadioButton,
                  ]}
                >
                  {formData.attendanceType === 'in-person' && (
                    <View style={styles.radioButtonInner} />
                  )}
                </View>
                <View style={styles.attendanceOptionTextContainer}>
                  <Text
                    style={[
                      styles.attendanceOptionTitle,
                      fairDetails.isVirtual && styles.disabledText,
                    ]}
                  >
                    In-Person
                  </Text>
                  <Text
                    style={[
                      styles.attendanceOptionDescription,
                      fairDetails.isVirtual && styles.disabledText,
                    ]}
                  >
                    Attend physically at {fairDetails.location}
                  </Text>
                </View>
              </View>
              {fairDetails.isVirtual && (
                <Text style={styles.notAvailableText}>
                  Not available for this fair
                </Text>
              )}
            </TouchableOpacity>

            <TouchableOpacity
              style={[
                styles.attendanceOption,
                formData.attendanceType === 'virtual' &&
                  styles.selectedAttendanceOption,
              ]}
              onPress={() => handleAttendanceTypeChange('virtual')}
            >
              <View style={styles.attendanceOptionContent}>
                <View
                  style={[
                    styles.radioButton,
                    formData.attendanceType === 'virtual' &&
                      styles.selectedRadioButton,
                  ]}
                >
                  {formData.attendanceType === 'virtual' && (
                    <View style={styles.radioButtonInner} />
                  )}
                </View>
                <View style={styles.attendanceOptionTextContainer}>
                  <Text style={styles.attendanceOptionTitle}>Virtual</Text>
                  <Text style={styles.attendanceOptionDescription}>
                    Attend online via our virtual platform
                  </Text>
                </View>
              </View>
            </TouchableOpacity>
          </View>
          {errors.attendanceType && (
            <Text style={styles.errorText}>{errors.attendanceType}</Text>
          )}
        </View>
      )}

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Special Requirements (Optional)</Text>
        <TextInput
          style={styles.textArea}
          placeholder="Enter any special requirements or accommodations you may need"
          multiline
          numberOfLines={4}
          textAlignVertical="top"
          value={formData.specialRequirements}
          onChangeText={text => handleInputChange('specialRequirements', text)}
        />
      </View>
    </View>
  );

  // Render step 4: Review and Submit
  const renderStep4 = () => (
    <View style={styles.stepContainer}>
      <Text style={styles.stepTitle}>Review and Submit</Text>
      <Text style={styles.stepDescription}>
        Please review your registration details before submitting.
      </Text>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Career Fair</Text>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Event:</Text>
          <Text style={styles.reviewItemValue}>{fairDetails?.title}</Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Date:</Text>
          <Text style={styles.reviewItemValue}>
            {formatDate(fairDetails?.date)}
          </Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Time:</Text>
          <Text style={styles.reviewItemValue}>{fairDetails?.time}</Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Location:</Text>
          <Text style={styles.reviewItemValue}>{fairDetails?.location}</Text>
        </View>
        {fairDetails?.hasVirtualOption && (
          <View style={styles.reviewItem}>
            <Text style={styles.reviewItemLabel}>Attendance:</Text>
            <Text style={styles.reviewItemValue}>
              {formData.attendanceType === 'in-person'
                ? 'In-Person'
                : 'Virtual'}
            </Text>
          </View>
        )}
      </View>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Personal Information</Text>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Name:</Text>
          <Text
            style={styles.reviewItemValue}
          >{`${formData.firstName} ${formData.lastName}`}</Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Email:</Text>
          <Text style={styles.reviewItemValue}>{formData.email}</Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Phone:</Text>
          <Text style={styles.reviewItemValue}>{formData.phone}</Text>
        </View>
      </View>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Education</Text>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>University:</Text>
          <Text style={styles.reviewItemValue}>{formData.university}</Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Degree:</Text>
          <Text style={styles.reviewItemValue}>{formData.degree}</Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Graduation:</Text>
          <Text style={styles.reviewItemValue}>{formData.graduationYear}</Text>
        </View>
      </View>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Areas of Interest</Text>
        <View style={styles.interestTagsContainer}>
          {formData.interests.map(interest => (
            <View key={interest} style={styles.interestTag}>
              <Text style={styles.interestTagText}>{interest}</Text>
            </View>
          ))}
        </View>
      </View>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Uploaded Documents</Text>
        {formData.resume ? (
          <View style={styles.reviewItem}>
            <Text style={styles.reviewItemLabel}>Resume:</Text>
            <Text style={styles.reviewItemValue}>{formData.resume.name}</Text>
          </View>
        ) : (
          <Text style={styles.reviewParagraph}>No resume uploaded</Text>
        )}
      </View>

      {formData.specialRequirements && (
        <View style={styles.reviewSection}>
          <Text style={styles.reviewSectionTitle}>Special Requirements</Text>
          <Text style={styles.reviewParagraph}>
            {formData.specialRequirements}
          </Text>
        </View>
      )}

      <View style={styles.termsContainer}>
        <Text style={styles.termsText}>
          By submitting this registration, you agree to our Terms of Service and
          Privacy Policy. You also confirm that all information provided is
          accurate and complete.
        </Text>
      </View>
    </View>
  );

  // Render step content based on current step
  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4();
      default:
        return null;
    }
  };

  // Render navigation buttons
  const renderNavButtons = () => (
    <View style={styles.navButtonsContainer}>
      {currentStep > 1 && (
        <TouchableOpacity style={styles.prevButton} onPress={handlePrevStep}>
          <Ionicons name="arrow-back" size={20} color="#0e4e96" />
          <Text style={styles.prevButtonText}>Previous</Text>
        </TouchableOpacity>
      )}

      {currentStep < 4 ? (
        <TouchableOpacity style={styles.nextButton} onPress={handleNextStep}>
          <Text style={styles.nextButtonText}>Next</Text>
          <Ionicons name="arrow-forward" size={20} color="#ffffff" />
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          style={styles.submitButton}
          onPress={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <ActivityIndicator size={20} color="#ffffff" />
          ) : (
            <>
              <Text style={styles.submitButtonText}>Register Now</Text>
              <Ionicons name="checkmark" size={20} color="#ffffff" />
            </>
          )}
        </TouchableOpacity>
      )}
    </View>
  );

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#ffffff" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Career Fair Registration</Text>
        <JobengLogo />
      </View>

      {/* Fair Info */}
      {!isLoading && fairDetails && (
        <View style={styles.fairInfoContainer}>
          <View style={styles.fairLogoContainer}>
            <Image
              source={{ uri: (fairDetails.logo && fairDetails.logo.startsWith('http')) ? fairDetails.logo : undefined }}
              style={styles.fairLogo}
              defaultSource={require('../../../assets/default-company.png')}
            />
          </View>
          <View style={styles.fairInfoContent}>
            <Text style={styles.fairTitle} numberOfLines={2}>
              {fairDetails.title}
            </Text>
            <Text style={styles.fairOrganizer}>{fairDetails.organizer}</Text>
            <View style={styles.fairDetailsRow}>
              <View style={styles.fairDetailItem}>
                <Ionicons name="calendar-outline" size={14} color="#64748B" />
                <Text style={styles.fairDetailText}>
                  {formatDate(fairDetails.date)}
                </Text>
              </View>
              <View style={styles.fairDetailItem}>
                <Ionicons name="location-outline" size={14} color="#64748B" />
                <Text style={styles.fairDetailText}>
                  {fairDetails.location}
                </Text>
              </View>
            </View>
          </View>
        </View>
      )}

      {/* Content */}
      {isLoading ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading career fair details...</Text>
        </View>
      ) : errors.general ? (
        renderError()
      ) : (
        <Animated.View
          style={[
            styles.contentContainer,
            {
              opacity: fadeAnim,
              transform: [{ translateY: slideAnim }],
            },
          ]}
        >
          {/* Step Indicator */}
          {renderStepIndicator()}

          {/* Form Content */}
          <ScrollView
            ref={scrollViewRef}
            style={styles.scrollView}
            contentContainerStyle={styles.scrollViewContent}
            showsVerticalScrollIndicator={false}
          >
            {renderStepContent()}

            {/* Navigation Buttons */}
            {renderNavButtons()}

            {/* Bottom Padding */}
            <View style={styles.bottomPadding} />
          </ScrollView>
        </Animated.View>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#F8FAFC',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  fairInfoContainer: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  fairLogoContainer: {
    marginRight: 12,
  },
  fairLogo: {
    width: 50,
    height: 50,
    borderRadius: 8,
    backgroundColor: '#F1F5F9',
  },
  fairInfoContent: {
    flex: 1,
  },
  fairTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#0F172A',
    marginBottom: 4,
  },
  fairOrganizer: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 4,
  },
  fairDetailsRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  fairDetailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
  },
  fairDetailText: {
    fontSize: 12,
    color: '#64748B',
    marginLeft: 4,
  },
  contentContainer: {
    flex: 1,
  },
  stepIndicatorContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  stepIndicator: {
    alignItems: 'center',
  },
  stepCircle: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: '#F1F5F9',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 4,
  },
  activeStepCircle: {
    backgroundColor: '#0e4e96',
  },
  stepNumber: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#64748B',
  },
  activeStepNumber: {
    color: '#ffffff',
  },
  stepLabel: {
    fontSize: 12,
    color: '#64748B',
  },
  activeStepLabel: {
    color: '#0e4e96',
    fontWeight: '500',
  },
  stepConnector: {
    flex: 1,
    height: 2,
    backgroundColor: '#E2E8F0',
    marginHorizontal: 4,
  },
  scrollView: {
    flex: 1,
  },
  scrollViewContent: {
    paddingBottom: 20,
  },
  stepContainer: {
    padding: 20,
    backgroundColor: '#ffffff',
    marginHorizontal: 16,
    marginTop: 16,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  stepTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#0F172A',
    marginBottom: 8,
  },
  stepDescription: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 20,
  },
  formGroup: {
    marginBottom: 20,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 8,
  },
  inputDescription: {
    fontSize: 12,
    color: '#64748B',
    marginBottom: 8,
  },
  input: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 16,
    color: '#0F172A',
  },
  inputError: {
    borderColor: '#EF4444',
  },
  errorText: {
    fontSize: 12,
    color: '#EF4444',
    marginTop: 4,
  },
  textArea: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 16,
    color: '#0F172A',
    minHeight: 100,
  },
  interestsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 8,
  },
  interestChip: {
    backgroundColor: '#F1F5F9',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 20,
    paddingHorizontal: 12,
    paddingVertical: 6,
    margin: 4,
  },
  selectedInterestChip: {
    backgroundColor: '#EBF5FF',
    borderColor: '#0e4e96',
  },
  interestChipText: {
    fontSize: 14,
    color: '#64748B',
  },
  selectedInterestChipText: {
    color: '#0e4e96',
    fontWeight: '500',
  },
  uploadButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F1F5F9',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    marginBottom: 10,
  },
  uploadButtonText: {
    fontSize: 14,
    color: '#0F172A',
    marginLeft: 8,
  },
  attendanceOptions: {
    marginTop: 8,
  },
  attendanceOption: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    padding: 12,
    marginBottom: 10,
  },
  selectedAttendanceOption: {
    borderColor: '#0e4e96',
    backgroundColor: '#F0F9FF',
  },
  attendanceOptionContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  radioButton: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#CBD5E1',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  selectedRadioButton: {
    borderColor: '#0e4e96',
  },
  disabledRadioButton: {
    borderColor: '#CBD5E1',
    backgroundColor: '#F1F5F9',
  },
  radioButtonInner: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: '#0e4e96',
  },
  attendanceOptionTextContainer: {
    flex: 1,
  },
  attendanceOptionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 2,
  },
  attendanceOptionDescription: {
    fontSize: 14,
    color: '#64748B',
  },
  disabledText: {
    color: '#94A3B8',
  },
  notAvailableText: {
    fontSize: 12,
    color: '#EF4444',
    fontStyle: 'italic',
    marginTop: 8,
    marginLeft: 32,
  },
  reviewSection: {
    marginBottom: 20,
    backgroundColor: '#F8FAFC',
    borderRadius: 8,
    padding: 12,
  },
  reviewSectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 12,
  },
  reviewItem: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  reviewItemLabel: {
    fontSize: 14,
    color: '#64748B',
    width: 100,
  },
  reviewItemValue: {
    fontSize: 14,
    color: '#0F172A',
    flex: 1,
    fontWeight: '500',
  },
  reviewParagraph: {
    fontSize: 14,
    color: '#0F172A',
    lineHeight: 20,
  },
  interestTagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  interestTag: {
    backgroundColor: '#EBF5FF',
    borderRadius: 16,
    paddingHorizontal: 10,
    paddingVertical: 4,
    margin: 4,
  },
  interestTagText: {
    fontSize: 12,
    color: '#0e4e96',
    fontWeight: '500',
  },
  termsContainer: {
    marginBottom: 20,
  },
  termsText: {
    fontSize: 12,
    color: '#64748B',
    lineHeight: 18,
  },
  navButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: 16,
    marginTop: 20,
  },
  prevButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F1F5F9',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  prevButtonText: {
    fontSize: 16,
    color: '#0e4e96',
    fontWeight: '600',
    marginLeft: 8,
  },
  nextButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#0e4e96',
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginLeft: 'auto',
  },
  nextButtonText: {
    fontSize: 16,
    color: '#ffffff',
    fontWeight: '600',
    marginRight: 8,
  },
  submitButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#0e4e96',
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginLeft: 'auto',
  },
  submitButtonText: {
    fontSize: 16,
    color: '#ffffff',
    fontWeight: '600',
    marginRight: 8,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: '#64748B',
  },
  errorContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#0F172A',
    marginTop: 16,
    marginBottom: 8,
  },
  errorMessage: {
    fontSize: 16,
    color: '#64748B',
    textAlign: 'center',
    marginBottom: 20,
  },
  errorButton: {
    backgroundColor: '#0e4e96',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  errorButtonText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '600',
  },
  bottomPadding: {
    height: 40,
  },
});
